import { type TCollectionSimple as TApiCollectionSimple } from '@core/api'

import { type TCollectionSimple } from '@core/models'

import { COLLECTION_LIKED_COVER } from './collectionLikedCover'
import { convertCrossLinkTag } from './convertCrossLinkTag'

export const convertCollectionSimple = (
    apiCollectionSimple: TApiCollectionSimple,
): TCollectionSimple => {
    return {
        id: apiCollectionSimple.id,
        type: apiCollectionSimple.type,
        authorId: apiCollectionSimple.user_id,
        authorUsername: apiCollectionSimple.username,
        authorDisplayName: apiCollectionSimple.author_name,
        slug: apiCollectionSimple.slug,
        title: apiCollectionSimple.title,
        imageUrl:
            apiCollectionSimple.type === 'liked'
                ? COLLECTION_LIKED_COVER
                : apiCollectionSimple.image,
        itemsCount: apiCollectionSimple.items_count,
        isPublic: apiCollectionSimple.is_public,
        isBrowsable: apiCollectionSimple.is_browsable,
        isPrivate: apiCollectionSimple.is_private,
        isImmutable: apiCollectionSimple.is_immutable,
        tags: apiCollectionSimple.tags,
        avatarUrl: apiCollectionSimple.avatar,
        description: apiCollectionSimple.description,
        isDownloadable: apiCollectionSimple.is_downloadable,
        seoTitle: apiCollectionSimple.seo_title,
        dateCreated: apiCollectionSimple.date_created,
        crossLinkTags: (apiCollectionSimple.cross_link_tags ?? []).map(convertCrossLinkTag),
        releaseId: apiCollectionSimple.release_id,
    }
}
